import MasterTab from 'src/components/Layouts/MasterTab.vue';
import HourHour from "src/views/Pages/Dashboard/Grow/Reports/HourHour/HourHour.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const HourHourRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'hourreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.hour_report',
          component: HourHour,
          meta: {
            prefix_permission: 'grow_hourreport',
          },
        },
      ],
    },
  ],
};

export default HourHourRoutes;